import { motion } from 'framer-motion';

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
};

export default function Thesis() {
  return (
    <section id="thesis" className="py-24 md:py-36" data-testid="thesis-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="section-divider mb-12" />

        <motion.p className="section-number" {...fadeUp} data-testid="thesis-number">
          05 / Thesis
        </motion.p>
        <motion.h2
          className="section-title mt-3 mb-14 md:mb-20"
          {...fadeUp}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          data-testid="thesis-title"
        >
          The Gap Between Ideas
          <br />
          and Reality Is Not Technical.
        </motion.h2>

        <div className="thesis-body" data-testid="thesis-body">
          <motion.p
            {...fadeUp}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            data-testid="thesis-p1"
          >
            Most ideas don&apos;t fail because of technology. They fail because
            no one helps translate them from abstract ambition into tangible form.
            The tools exist. The platforms exist. What&apos;s missing is the bridge &mdash;
            someone who can see the idea clearly, understand the technology,
            and design the path from one to the other.
          </motion.p>

          <motion.p
            {...fadeUp}
            transition={{ duration: 0.8, delay: 0.25, ease: [0.16, 1, 0.3, 1] }}
            data-testid="thesis-p2"
          >
            That&apos;s what Civic Ventures exists to do. We believe the most
            valuable work ahead won&apos;t be building more software &mdash;
            it will be helping people understand what to build, and why.
            AI has made creation faster, but it hasn&apos;t made vision clearer.
            Strategy, taste, and creative judgment still require a human
            operating system.
          </motion.p>

          <motion.p
            {...fadeUp}
            transition={{ duration: 0.8, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
            data-testid="thesis-p3"
          >
            We started this studio because we kept meeting people with
            extraordinary ideas and no clear next step. Founders who could
            describe the future but couldn&apos;t architect the path. Businesses
            sitting on opportunities they couldn&apos;t see. Creators with ambition
            but no framework. This studio is the framework.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
